import {gql} from "@apollo/client";

export interface UnblockSlotQuery {
    unblock: Boolean
}

export const UNBLOCK_SLOT = gql`
    mutation UnblockSlot($slot: ID!, $calendar: ID!) {
        unblock(
            slot: $slot,
            calendar: $calendar
        )
    }
`
